/* tslint:disable:typedef-whitespace align no-trailing-whitespace */

import { Router                } from '@angular/router';
import { AuthenticationService } from '@/services/authentication.service';
import { Action, ActionType    } from '@/models/action';
import { User                  } from '@/models/user';
import { Logger                } from '@/util/logger';

/**
 *
 * @class AdminAction
 *
 * @brief navigation action - go to the top level admin page
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      March 2020
 *
 */
export class AdminAction extends Action {

  private auth: AuthenticationService = null;

  constructor(
    private   router: Router,
             options: any = null
  ) {

    super({
      key:   'admin.admin',
      type:  ActionType.Admin_Admin,
      label: 'Administration',
      icon:  '<i class="fas fa-tools"></i>',
      tip:   'Go to the admin area'
    });

    this.auth     = this.injector().get(AuthenticationService);

  }

  /* is this action enabled? */
  public enabled(): boolean {

    /* only enabled if this user is an administrator */

    const currentUser: User = this.auth.userOfSession;

    if (currentUser) {

      if (currentUser.isAdmin) {

        return true;
      }

    }

    return false;
  }

  /** implement the action */
  public execute(): boolean {

    if (!this.enabled()) {
      return false;
    }

    Logger.debug('[AdminAction] jumping to admin page...');

    this.router.navigate(['/administration']);
  }
}
